'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _pageLocal = require('./page.local.css');

var _pageLocal2 = _interopRequireDefault(_pageLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PageTitle = function PageTitle(_ref) {
  var icon = _ref.icon,
      back = _ref.back,
      title = _ref.title;

  var backLink = back && _react2.default.createElement(back.Link, {
    to: back.to,
    className: (0, _classnames2.default)(_pageLocal2.default.backLink, back.className)
  }, String.fromCharCode('0x2190'), ' ', back.text);

  return _react2.default.createElement('div', {
    className: _pageLocal2.default.pageTitle
  }, backLink, _react2.default.createElement('h1', null, icon && _react2.default.createElement(_icon2.default, {
    icon: icon,
    className: _pageLocal2.default.pageTitleIcon
  }), title));
};

PageTitle.propTypes = {
  /**
   * Text to display as title of the page
   */
  title: _propTypes2.default.string.isRequired,

  /**
   * Optional icon to place in front of the title text
   */
  icon: _propTypes2.default.string,

  /**
   * Adds a "Back" button above the title
   */
  back: _propTypes2.default.shape({
    Link: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]).isRequired,
    className: _propTypes2.default.string,
    to: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired
  })
};
exports.default = PageTitle;